import Storage from "./helpers/Storage";

const hostAddress = window.location.host.includes("localhost:") ? "https://192.168.100.56:9090/" : `${window.location.protocol}//${window.location.host}/`;

const config = {
    baseUrl: hostAddress,
    sentryDSN: `${hostAddress.split("//")?.shift()}//0000@${hostAddress.split("//")?.pop()}`,
    root: '/',
    owner: 'نام مرکز',
    spax: ' ',
    lang: 'fa',
    calendar: 'Solar Hejri',
    doubleClickAction: 'Quick View',
    pageNum: 0,
    lastMonthReport: 1,
    daysBeforePanel: -31
};

export default config;